<template>
    <InformeCard title="Procedencia" id="total-entradas" name="total-entradas" collapsable="true" style="margin: 0;">
        <TotalEntradasPorCP :event_id="event_id" @totalEntradasCP="emitEntradasPorCP($event)"/>
        <TotalEntradasPorProvincia :event_id="event_id" @totalEntradasProvincia="emitEntradasPorProvincia($event)"/>
    </InformeCard>
</template>

<script>
    import InformeCard from "../InformeCard";
    import TotalEntradasPorProvincia from "./components/TotalEntradasPorProvincia"
    import TotalEntradasPorCP from "./components/TotalEntradasPorCP";

    export default {
        props: ['event_id'],
        components: {
            InformeCard, TotalEntradasPorProvincia, TotalEntradasPorCP
        },
        methods: {
            emitEntradasPorProvincia(totalEntradasProvincia) {
                this.$emit('entradasPorProvincia', totalEntradasProvincia);
            },

            emitEntradasPorCP(totalEntradasCP) {
                this.$emit('entradasPorCP', totalEntradasCP);
            },
        }
    }

</script>